import React, { useEffect, useState } from 'react';
import styles from './OrgReviewList.module.scss';
import crossIcon from '../../../../src/assets/images/xcircle.svg';
import closeIcon from '../../../../src/assets/images/close-Icon.svg';
import classes from '../../../styles/common/common-styles.module.scss';
import Button from '../button/Button';
import ErrorMsg from '../error/ErrorMsg';

const OrgReviewList = props => {
  const [disableNextBtn, setDisableNextBtn] = useState(false);

  const getInputs = inputArray => {
    if (inputArray.length === 0) {
      return [''];
    } else {
      return inputArray;
    }
  };

  const checkIfMandatory = (org, policyIndex) => {
    const isMandatory =
      org?.orgReferenceList &&
      JSON.parse(org.orgReferenceList).OrganisationFieldDetails[0].mandatory;
    const isFieldEmpty = org?.policyNumber[policyIndex] === '';
    if (isMandatory) {
      return isFieldEmpty;
    }
    return false;
  };

  const checkIfValid = (org, policyIndex) => {
    const regex =
      org?.orgReferenceList &&
      JSON.parse(org.orgReferenceList).OrganisationFieldDetails[0].fieldFormat;
    const policy = org?.policyNumber[policyIndex];
    if (!policy) {
      return false;
    }

    return !new RegExp(regex).test(policy);
  };

  const toSentenceCase = camelCase => {
    if (camelCase?.includes('ID')) {
      return camelCase;
    }
    if (camelCase) {
      const result = camelCase.replace(/([A-Z])/g, ' $1').trim();
      return result[0].toUpperCase() + result.substring(1).toLowerCase();
    }
    return '';
  };

  useEffect(() => {
    // check for mandatory fields
    let hasEmptyField = [];
    let isValidInput = [];
    const data = props.selectedNotifiableOrganisations.map(org => {
      // check for empty field
      if (
        org?.orgReferenceList &&
        JSON.parse(org?.orgReferenceList).OrganisationFieldDetails[0].mandatory
      ) {
        hasEmptyField.push(org.policyNumber?.includes(''));
      }

      // check for regex
      if (
        org?.orgReferenceList &&
        JSON.parse(org?.orgReferenceList)?.OrganisationFieldDetails[0]?.fieldFormat
      ) {
        const regex = JSON.parse(org?.orgReferenceList)?.OrganisationFieldDetails[0]?.fieldFormat;
        const validity = org.policyNumber?.map(number => new RegExp(regex).test(number));
        isValidInput.push(validity);
      }
    });

    // no field should be empty or invalid
    const condition = hasEmptyField.includes(true) || isValidInput.flat().includes(false);
    setDisableNextBtn(condition);
  }, [props.selectedNotifiableOrganisations]);

  return (
    <div className="app">
      <div className={` ${props.isSelectionPanelOpen ? styles.open : null}`}>
        <div className={`${styles.sidenav}`}>
          <div className={`${styles.wrapper}`}>
            {/* page title */}
            {props.selectedNotifiableOrganisations.length > 0 ? (
              <h3 className={`${classes.pageTitle} ${styles.pageTitle}`}>
                {props.selectedNotifiableOrganisations.length}{' '}
                {props.selectedNotifiableOrganisations.length === 1
                  ? 'organisation'
                  : 'organisations'}{' '}
                added
              </h3>
            ) : null}
            {/* org list */}
            {[...props.selectedNotifiableOrganisations].map((z, orgindex) => (
              <div className={`${styles.orgName} ${styles.additionalInfo}`}>
                <div className={`${styles.additioanOrgInfo}`}>
                  <div className={styles.logoWrap}>
                    <img src={z.logo} alt="logo" />
                  </div>
                  <div className={styles.name} translate="no">
                    {' '}
                    {z.label}{' '}
                    {!JSON.parse(z?.orgReferenceList)?.OrganisationFieldDetails[0]?.fieldName && (
                      <p className={styles.noFurtherDetails}>No further details required</p>
                    )}
                  </div>
                  <div className={styles.additionalInputWrap}>
                    <p className={styles.fieldName}>
                      {toSentenceCase(
                        JSON.parse(
                          z?.orgReferenceList
                        )?.OrganisationFieldDetails[0]?.fieldName.trim()
                      )}
                    </p>
                    <p>
                      {JSON.parse(z?.orgReferenceList)?.OrganisationFieldDetails[0]
                        ? JSON.parse(z?.orgReferenceList)?.OrganisationFieldDetails[0]?.mandatory
                          ? 'Required'
                          : 'Optional'
                        : ''}
                    </p>

                    {JSON.parse(z?.orgReferenceList)?.OrganisationFieldDetails[0]?.fieldName &&
                      [...getInputs(z.policyNumber)].map((val1, policyIndex) => (
                        <div key={orgindex + policyIndex} className={'mt-2'}>
                          <div className={`d-flex align-items-center ${styles.questionWrap}`}>
                            <input
                              value={val1}
                              id={'policyNumberInput'}
                              className={`nsw-form-input ${classes.nswFormInput} ${
                                styles.additionalInfoInput
                              } ${
                                props.isValidValue[orgindex] &&
                                props.isValidValue[orgindex].length > 0 &&
                                !props.isValidValue[orgindex][policyIndex]
                                  ? styles.error
                                  : ''
                              }`}
                              placeholder={props.type}
                              onChange={async e => {
                                props.validateInput(
                                  JSON.parse(z.orgReferenceList).OrganisationFieldDetails[0]
                                    .fieldFormat,
                                  e.target.value,
                                  orgindex,
                                  policyIndex
                                );
                                props.updatePolicyNumber(e.target.value, policyIndex, z.label);
                              }}
                            />
                            {z.policyNumber.length > 1 ? (
                              <a
                                tabIndex="0"
                                href="javascript:void(0)"
                                onClick={() =>
                                  props.removePolicyNumber(orgindex, policyIndex, z.label)
                                }
                                onKeyPress={event => {
                                  if (event.key === 'Enter') {
                                    props.removePolicyNumber(orgindex, policyIndex, z.label);
                                  }
                                }}
                              >
                                <img
                                  src={closeIcon}
                                  alt="delete icon"
                                  className={`${styles.deleteRecord}`}
                                />
                              </a>
                            ) : null}
                          </div>
                          {checkIfValid(z, policyIndex) ? (
                            <ErrorMsg
                              id={'deceasedEmailAddressErrorMessage'}
                              type={'error'}
                              description={`Invalid account number. Check the information entered and try again.`}
                            />
                          ) : null}

                          {checkIfMandatory(z, policyIndex) ? (
                            <ErrorMsg
                              id={'deceasedEmailAddressErrorMessage'}
                              type={'error'}
                              description={`This field cannot be left empty.`}
                            />
                          ) : null}
                        </div>
                      ))}
                    <div className={styles.addAnotherLabel}>
                      {[...getInputs(z.policyNumber)].pop() !== '' && z.policyNumber.length < 5 ? (
                        <span onClick={() => props.addPolicyNumber(z.label)}>+ Add</span>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className={styles.deleteIcon}>
                  {' '}
                  <img
                    src={crossIcon}
                    tabIndex="0"
                    href="javascript:void(0)"
                    alt="delete icon"
                    onClick={() => {
                      const list = props.selectedNotifiableOrganisations.filter(
                        item => item.label !== z.label
                      );
                      props.setSelectedOrganisations(list);
                    }}
                    onKeyPress={event => {
                      if (event.key === 'Enter') {
                        const list = props.selectedNotifiableOrganisations.filter(
                          item => item.label !== z.label
                        );
                        props.setSelectedOrganisations(list);
                      }
                    }}
                  />
                </div>
              </div>
            ))}

            {props.selectedNotifiableOrganisations.length > 0 && (
              <div>
                <div className={`d-flex ${styles.btnWrap}`}>
                  <Button
                    disabled={disableNextBtn}
                    onClick={() => {
                      if (props.isValid()) {
                        props.storeData();
                        window.scrollTo(0, 0);
                        props.history.push(props.continuePath);
                      } else {
                        props.scrollToError();
                      }
                    }}
                  >
                    Next
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrgReviewList;
